import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
const NewPromotions = dynamic(() => import('./NewPromotions').then(mod => mod.NewPromotions));
export const NewPromotionsConfig = {
  emptyLabel: 'NewPromotions',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/newpromotions`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const NewPromotionsEditable = (props: any) => {
  return (
    <EditableComponent config={NewPromotionsConfig} {...props}>
      <NewPromotions {...props} />
    </EditableComponent>
  );
};
